import React, { useState } from 'react';
import {
  CardList,
  Container,
  Header,
  StyledHelpLink,
  StyledTitle,
  StyledModal
} from './styles';
import PrinterCard from '../PrinterCard/PrinterCard';
import PrinterComparison from '../../PrinterComparison/PrinterComparison';
import { PrinterItem } from 'src/utils/Products/productFilter';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';
interface PrinterDetailsProps {
  nonCurrentPrinterDetails?: PrinterItem[];
  currentPrinterDetails?: PrinterItem[];
}

const OtherPrinterComponent = ({
  nonCurrentPrinterDetails,
  currentPrinterDetails
}: PrinterDetailsProps): JSX.Element => {
  const [selectedId, setSelectedId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const nonRecommendedPrinters = nonCurrentPrinterDetails?.filter(
    (p: PrinterItem) => p.recommendedPrinter === false
  );
  const getText = useTranslationHelper();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Container>
      <Header>
        <StyledTitle>
          {getText(
            'selectionTitle',
            'You can select a different printer model'
          )}
        </StyledTitle>
        <StyledHelpLink onClick={handleOpenModal}>
          {getText('selectionSubtitle', 'Not sure which model you need?')}
        </StyledHelpLink>
      </Header>
      <CardList>
        {nonRecommendedPrinters.map((printer: PrinterItem) => (
          <PrinterCard
            key={printer.productSKU}
            nonCurrentPrinterDetails={printer}
            currentPrinterDetails={currentPrinterDetails}
            selectionState={{
              selected: selectedId === printer.productSKU,
              isCurrent: true,
              onSelect: () => setSelectedId(printer.productSKU)
            }}
          />
        ))}
      </CardList>

      {isModalOpen && (
        <StyledModal
          data-testid="modal"
          closeButton
          show={isModalOpen}
          onClose={handleCloseModal}
          closeOnBlur={false}
        >
          <PrinterComparison printerDetails={nonCurrentPrinterDetails} />
        </StyledModal>
      )}
    </Container>
  );
};

export default OtherPrinterComponent;
